"use client";

import { FC, useMemo } from "react";

import { useUndressContext } from "@/providers";
import { cn } from "@/utils/cn";

import { UIWrapper } from "./UIWrapper";

/**
 * Компонент VideoBlockResult отвечает за отображение видеоблока с результатом генерации.
 */
export const VideoBlockResult: FC = () => {
  // Деструктурируем нужные данные из useUndressContext
  const { clickFileId, clickUndressStatus, loading, undressings } =
    useUndressContext();

  const { isUndressing, isError, isBlur } = clickUndressStatus;

  /**
   * Мемозируем текущий объект undress, основываясь на clickFileId.
   * Если undressings нет, возвращаем undefined.
   */
  const undress = useMemo(() => {
    if (!undressings) {
      return;
    }
    return undressings.find(({ id }) => id === clickFileId);
  }, [clickFileId, undressings]);

  /**
   * Блюрим видео по условиям:
   * - ожидаем ответ сервера
   * - идет обработка
   * - ошибка генерации
   * - гостевой блюр
   * - закончились коины
   * - загрузка псевдогенерации
   */
  const isBluredVideo = useMemo(
    () => loading || isUndressing || isError || isBlur,
    [isBlur, isError, isUndressing, loading],
  );

  // Извлекаем параметры видео из videoSettings
  const video = undress?.fileUrl;

  // Если видео не задано, ничего не отображаем.
  if (!video) {
    return null;
  }

  return (
    <UIWrapper>
      <video
        loop
        autoPlay
        muted
        playsInline
        className={cn("size-full object-contain", isBluredVideo && "blur-sm")}
      >
        <source src={video} type="video/mp4" />
        <p>Your browser does not support embedded video.</p>
      </video>
    </UIWrapper>
  );
};

VideoBlockResult.displayName = "VideoBlockResult";
